export default {
    spinnerContainer: {
        textAlign: 'center',
        width: 100,
        margin: '20px auto',
    },
};
